import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('filter-news-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        toggleFilter(event) {
            const filterBlock = event.currentTarget.parentElement;
            const filterList = event.currentTarget.nextElementSibling;

            if (filterBlock.classList.contains('active')) {
                filterBlock.classList.remove('active');
                gsap.to(filterList, 0.3, {
                    height: 0,
                    ease: 'Quad.easeOut',
                });
            } else {
                filterBlock.classList.add('active');
                gsap.to(filterList, 0.3, {
                    height: 'auto',
                    ease: 'power4.out',
                });
            }
        },

        setCategory(category) {
            const url = new URL(window.location.href);
            url.searchParams.set('category', category);

            window.location = url;
        },

        setTopic(topic) {
            const url = new URL(window.location.href);
            url.searchParams.set('topic', topic);

            window.location = url;
        },

        removeParams(sParam) {
            let url = `${window.location.href.split('?')[0]}?`;
            const sPageURL = decodeURIComponent(window.location.search.substring(1));
            const sURLVariables = sPageURL.split('&');
            let sParameterName;
            let i;

            for (i = 0; i < sURLVariables.length; i++) {
                sParameterName = sURLVariables[i].split('=');
                if (sParameterName[0] !== sParam) {
                    url = `${url + sParameterName[0]}=${sParameterName[1]}&`;
                }
            }
            return url.substring(0, url.length - 1);
        },

        removeTopic() {
            window.location = this.removeParams('topic');
        },

        removeCategory() {
            window.location = this.removeParams('category');
        },
    },
});
